import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { FindingGroup, RelatedFinding } from '../../findingDetails/findingDetails/types';

export default class EasmRelatedFindingsDataProvider extends BaseWebComponentDataProvider {
  public getFindingGroups(allFindingGroups: FindingGroup[], searchText: string): FindingGroup[] {
    if ('' === searchText) {
      return allFindingGroups;
    }

    const filteredFindingGroups: FindingGroup[] = [];

    for (const findingGroup of allFindingGroups) {
      const filteredItems = findingGroup.items.filter((finding: RelatedFinding): boolean =>
        this.matches(finding.name, searchText)
      );

      if (0 !== filteredItems.length) {
        filteredFindingGroups.push({ count: filteredItems.length, type: findingGroup.type, items: filteredItems });
      }
    }

    return filteredFindingGroups;
  }

  private matches(findingName: string, searchText: string): boolean {
    findingName = findingName.trim().toLowerCase();

    for (const searchWord of searchText.toLowerCase().split(/\s+/)) {
      if (!findingName.includes(searchWord)) {
        return false;
      }
    }

    return true;
  }
}
